import { render } from "./RateStar.vue?vue&type=template&id=43e3e5ea&scoped=true"
import script from "./RateStar.vue?vue&type=script&lang=js"
export * from "./RateStar.vue?vue&type=script&lang=js"

import "./RateStar.vue?vue&type=style&index=0&id=43e3e5ea&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e3e5ea"]])

export default __exports__